module.exports = "<div class=\"btn-group\" uib-dropdown id=\"testme\">\n  <button type=\"button\" class=\"btn btn-primary btn-xs\" uib-dropdown-toggle>\n    Export <span class=\"caret\"></span>\n  </button>\n  <ul role=\"menu\" uib-dropdown-menu=\"\">\n    <li><a ng-click=\"$ctrl.exportPdf()\">PDF</a></li>\n    <li><a ng-click=\"$ctrl.exportExcel()\">EXCEL</a></li>\n    <li><a ng-click=\"$ctrl.exportCsv()\">CSV</a></li>\n  </ul>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./client/common/tableExport/tableExport.html
// module id = 361
// module chunks = 0